export const Badges = {
  HIGH_RATING: 'HIGH_RATING',
  START_WORKING: 'START_WORKING'
}
